import { render, staticRenderFns } from "./EditInspectionItem.vue?vue&type=template&id=c2c937d6"
import script from "./EditInspectionItem.vue?vue&type=script&lang=js"
export * from "./EditInspectionItem.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports